module.exports = __webpack_public_path__ + "img/doc.e8de2e86.png";